import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import { getALLTeacher, getALLClass } from "../../../configs/redux/action";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import formatDate from "components/calendar/FormatDate";

const schema = yup
  .object({
    teacher_id: yup.number().positive().integer().required(),
    class_id: yup.number().positive().integer().required(),
    date: yup.string().required(),
    activity: yup.string().required(),
    note: yup.string().required(),
  })
  .required();

const ClassModal = ({
  isOpen,
  handleCloseModal,
  handleSaveChanges,
  getALLTeacher,
  dataTeacher,
  getALLClass,
  dataClass,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getALLTeacher();
    getALLClass();
  }, [getALLTeacher, getALLClass]);

  useEffect(() => {
    setValue("class_id", "");
    setValue("teacher_id", "");
    setValue("date", "");
    setValue("activity", "");
    setValue("note", "");
  }, []);

  const onSubmit = (data) => {
    handleSaveChanges(data);
    console.log(data);

  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Data</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FormControl mb={4}>
              <FormControl mb={4}>
                <FormLabel htmlFor="birth_date">Date</FormLabel>
                <Input type="date" id="date" {...register("date")} />
                {errors.date && (
                  <Text fontSize="xs" color="tomato">
                    {errors.date.message}
                  </Text>
                )}
              </FormControl>
              <FormLabel htmlFor="class_id">Class</FormLabel>
              <Select name="class_id" id="class_id" {...register("class_id")}>
                <option value="">Select Class</option>
                {dataClass.map((Class) => (
                  <option key={Class.id} value={Class.id}>
                    {Class.name}
                  </option>
                ))}
              </Select>
              {errors.teacher_id && (
                <Text fontSize="xs" color="tomato">
                  {errors.teacher_id.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="teacher_id">Teacher Name</FormLabel>
              <Select
                name="teacher_id"
                id="teacher_id"
                {...register("teacher_id")}
              >
                <option value="">Select Teacher</option>
                {dataTeacher.map((teacher) => (
                  <option key={teacher.id} value={teacher.id}>
                    {teacher.name}
                  </option>
                ))}
              </Select>
              {errors.teacher_id && (
                <Text fontSize="xs" color="tomato">
                  {errors.teacher_id.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="activity">Activity</FormLabel>
              <Textarea id="activity" {...register("activity")} />
              {errors.activity && (
                <Text fontSize="xs" color="tomato">
                  {errors.activity.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="note">Note</FormLabel>
              <Textarea id="note" {...register("note")} />
              {errors.note && (
                <Text fontSize="xs" color="tomato">
                  {errors.note.message}
                </Text>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} type="submit">
              Save Changes
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

const reduxState = (state) => ({
  dataTeacher: state.getData.dataTeacher.data,
  dataClass: state.getData.dataClass.data,
  loadingData: state.getData.dataTeacher.loading,
  LoadingData2: state.getData.dataClass.loading,
});

const reduxDispatch = (dispatch) => {
  return {
    getALLTeacher: () => dispatch(getALLTeacher()),
    getALLClass: () => dispatch(getALLClass()),
  };
};

export default connect(reduxState, reduxDispatch)(ClassModal);
